module.exports = __webpack_public_path__ + "img/quizz-step-10-1.552b2692.jpg";